import React, { Component } from 'react'
import { Form, Icon, Dimmer, Loader } from 'semantic-ui-react'
import Messages from './Messages'
import { List } from 'immutable'

export default function FormComponent({ children, onSubmit, formState, size, disableLoader = false, className = '' }) {
  let { messages = List(), loading = false } = formState

  return (
    <Form onSubmit={onSubmit} className={className + ' form-parent'} size={size}>
      {messages.size ? (
        <div className="form-messages">
          <Messages formState={formState} />
        </div>
      ) : null}
      {children}
      <Dimmer active={!disableLoader && loading} inverted>
        <Loader />
      </Dimmer>
    </Form>
  )
}
